import { getSolidStatusBadge } from "../Bookings/status";

const renderEventContent = (eventInfo: any) => {
  const { title, extendedProps } = eventInfo.event;
  return (
    <div className='text-start' >
      <div className="d-flex flex-column gap-1">
        <strong className="d-block" title={title}>{title}</strong>
        <small>{extendedProps.customerName}</small>
        <span>{getSolidStatusBadge(extendedProps.bookingStatus)}</span>
        <span><small>Total Amount: £{parseFloat(extendedProps.totalAmount || '0').toFixed(2)}</small></span>
        <span><small>Venue: {extendedProps.venue || extendedProps.address}</small></span>
      </div>
    </div>
  );
};

export default renderEventContent;